/**
 *
 * Custom function
 *
 */ 

(function($) {

	$(document).ready(function() {

		scrollAnimations(270, true);
		scrollAnimationsUp();

		$('.menu-struttura li a').on('click', function(e){
			e.preventDefault();
			var scrollTo=$($(this).attr('href'));
				$('html,body').animate({
					scrollTop: scrollTo.offset().top - $('header').height() - ($('body').is('.is-mobile')?-110:125)
				}, 'slow');
			window.scrollBy(0, -($('body').is('.is-mobile')?150:150));
			//console.log("should have scrolled...")
		});


		/*
		*	Attraverso il Google Loader carico il modulo mappa
		*/
		/*$.getScript('https://www.google.com/jsapi', function() {
			var map_params = 'language=' + lang + (google_api_key != '' ? '&key=' + google_api_key : '');
			google.load('maps', '3', {
					other_params: map_params,
					callback: function() {
							initializeGmap();
					}
			});
		});*/

		$('.btnCollapse').on('click', function() {
			$(this).find('i')
				.toggleClass('icon-edt-arrow-right')
				.toggleClass('icon-edt-arrow-down-3');
		});

	});

	

	// form contatti: aggiorno valori con select
	$('#input_1_60').change(function() {
		if ($(this).val() != '0') {
			$('#input_1_49').val($(this).find('option:selected').text());
			$('#input_1_53').val($(this).val());
			$('#input_1_52').val('');
			$('#input_1_54').val('');
		} else {
			$('#input_1_49').val(nome_sito);
			$('#input_1_53').val(0);
			$('#input_1_52').val(email_sito);
			$('#input_1_54').val(email_sito);
		}
	});

	if ( $('body').hasClass('single-strutture') ) {
		

		$('#gform_1').click(function(){
			$('#input_1_60').removeAttr("disabled");
			
			$("#input_1_60 option").each(function()
			{
				if ( $(this).val() == postidstruttura ) {
					$('#input_1_49').val($(this).text());
					$('#input_1_53').val($(this).val());
					$('#input_1_52').val('');
					$('#input_1_54').val('');
					$('#input_1_61').val(1);
					$('#input_1_60 option[value='+postidstruttura+']').attr('selected','selected');
				} 
			});
		});
	}

	function scrollAnimations(desktopScrollTop, desktopScrollBol) {

		var header = $('#js-header'),
				menu = $('#js-fixed-menu'),
				desktopFixedMenu = $('#js-desktopFixedMenu'),
				windowWidth = $(window).width();

		if ($('body').is('.is-mobile')) {
				var headerH = $('#js-header').outerHeight(), // Height compreso di margini e bordi
						menuH = $('#js-fixed-menu').innerHeight(), // Height senza margini e bordi
						scrollValue = headerH - menuH;

				header.css('height', headerH);

		}

		$(window).scroll(function() {
				scrolltop = $(window).scrollTop();

				if ($('body').is('.is-mobile')) {
					if ( scrolltop >= scrollValue) {
							menu.addClass("scroll");
					} else {
							menu.removeClass("scroll");
					}
				} else if ( desktopScrollBol ) {
					if (scrolltop >= desktopScrollTop) {
						header.addClass("scroll");
					} else {
						header.removeClass("scroll");
					}
				}

		});

	}

	/*
	 *	Funzione per l'inizializzazione della mappa
	 */
	/*function initializeGmap() {
			$('*[data-location]').each(function() {
					var map = $(this),
							address = map.attr('data-location');
					map.setGMap({
							address: address
					});
			});
	} // end func initializeGmap*/

	function scrollAnimationsUp(){

		var elements_up = $('.return-up');

		//if( !$("body").is('.is-mobile') ){
			$(window).scroll(function(){
				var scrolltop = $(window).scrollTop();

				if( scrolltop >= 800 ) elements_up.addClass("active");
				else elements_up.removeClass("active");
			});
		//}
	}

  $(window).load(function() {

		if ( $( window ).width() > 991 ) {

			$('.js-equalHeights-cf-thumb').equalHeights();
			$('.js-equalHeights-cf-title').equalHeights();
			$('.js-equalHeights-bm-thumb').equalHeights();
			$('.js-equalHeights-bm-title').equalHeights();
			$('.js-equalHeights-bm-descr').equalHeights();
			$('.js-equalHeights-servizi-thumb').equalHeights();
			//$('.js-equalHeights-servizi-testi').equalHeights();
			//$('.js-equalHeights-servizi-title').equalHeights();
			//$('.js-equalHeights-servizi-descr').equalHeights();
			$('.js-equalHeights-esclusiva-thumb').equalHeights();
			$('.js-equalHeights-esclusiva-title').equalHeights();
			$('.js-equalHeights-esclusiva-descr').equalHeights();
			$('.js-equalHeights-dulcis-thumb').equalHeights();
			$('.js-equalHeights-dulcis-title').equalHeights();
			$('.js-equalHeights-dulcis-descr').equalHeights();
			$('.js-equalHeights-strutture-footer').equalHeights();
			$('.js-equalHeights-slideshow-struttura').equalHeights();

		} else {
			//$('.js-equalHeights-servizi-title').equalHeights();
			//$('.js-equalHeights-servizi-descr').equalHeights();
			$('.js-equalHeights-servizi-testi').equalHeights();
		}
		$('.js-equalHeights-menu-struttura').equalHeights();

//		if ( $('body').is('.is-desktop')) {
		if ( $( window ).width() > 991 ) {
			$(".pinned").pin({containerSelector: ".richiestaPreventivoContainer"});
			//$(".pinned2").pin({containerSelector: ".richiestaPreventivoContainer"});
		}

	});

	$(window).resize(function() {

		if ( $( window ).width() > 991 ) {

			$('.js-equalHeights-cf-thumb').equalHeights();
			$('.js-equalHeights-cf-title').equalHeights();
			$('.js-equalHeights-bm-thumb').equalHeights();
			$('.js-equalHeights-bm-title').equalHeights();
			$('.js-equalHeights-bm-descr').equalHeights();
			$('.js-equalHeights-servizi-thumb').equalHeights();
			//$('.js-equalHeights-servizi-testi').equalHeights();
			//$('.js-equalHeights-servizi-title').equalHeights();
			//$('.js-equalHeights-servizi-descr').equalHeights();
			$('.js-equalHeights-esclusiva-thumb').equalHeights();
			$('.js-equalHeights-esclusiva-title').equalHeights();
			$('.js-equalHeights-esclusiva-descr').equalHeights();
			$('.js-equalHeights-dulcis-thumb').equalHeights();
			$('.js-equalHeights-dulcis-title').equalHeights();
			$('.js-equalHeights-dulcis-descr').equalHeights();
			$('.js-equalHeights-strutture-footer').equalHeights();
			$('.js-equalHeights-slideshow-struttura').equalHeights();

		} else {
			//$('.js-equalHeights-servizi-title').equalHeights();
			//$('.js-equalHeights-servizi-descr').equalHeights();
			$('.js-equalHeights-servizi-testi').equalHeights();
		}
		$('.js-equalHeights-menu-struttura').equalHeights();

	});

})(jQuery);

jQuery(function($){
  $(document).on('gform_post_render', function(e, form_id){
    $('#gform_ajax_frame_'+form_id).attr('src', 'about:blank');
  });
});
